// extracted by mini-css-extract-plugin
export default {"image-container":"Screen1_image-container__YCLQC","input-wrapper":"Screen1_input-wrapper__w3JKZ","btn":"Screen1_btn__Fh++w","text-bold":"Screen1_text-bold__LbJzz"};